import { Dialog } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import React from 'react'

import {
  ModalButtonBox,
  ModalCloseButton,
  ModalContainer,
  ModalContent,
  ModalHeader,
  ModalNoButton,
  ModalText,
  ModalTitle,
  ModalYesButton,
} from './styled'

interface ConfirmationModalProps {
  isOpen: boolean
  toggleModal: () => void
  onConfirm: () => void
  address: { firstname: string; lastname: string }
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  toggleModal,
  onConfirm,
  address,
}) => {
  return (
    <Dialog open={isOpen} onClose={toggleModal}>
      <ModalContainer>
        <ModalHeader>
          <ModalTitle>Remove Address</ModalTitle>
          <ModalCloseButton onClick={toggleModal}>
            <Close />
          </ModalCloseButton>
        </ModalHeader>
        <ModalContent>
          <ModalText>
            Are you sure you want to remove the address for {address.firstname} {address.lastname}?
          </ModalText>

          <ModalButtonBox>
            <ModalNoButton text="No, Go Back" onClick={toggleModal} />
            <ModalYesButton text="Yes, Remove Address" onClick={onConfirm} />
          </ModalButtonBox>
        </ModalContent>
      </ModalContainer>
    </Dialog>
  )
}

export default ConfirmationModal
